import React from 'react';
import { ModalBase } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import { useSelector } from 'react-redux';
import { FORM_ABANDON_EVENT, track } from '../../utils/trackingEvent';
import { selectProductTaxesParams } from '../../ducks/step4Module2';

function LeavePaymentForm({ onClose, openModal, handleRedirect }) {
  const { productId } = useSelector(selectProductTaxesParams);
  const { t } = useTranslation();

  const handleClick = evt => {
    if (productId) {
      track(FORM_ABANDON_EVENT, productId);
    }
    if (handleRedirect && typeof handleRedirect === 'function') {
      handleRedirect(evt);
    }
  };

  return (
    <ModalBase openModal={openModal} onClose={onClose} width='350px' height='190px'>
      <Container data-repa='modal-leavePaymentForm-container'>
        <Title>{t('publisher.modal.leavePaymentForm.title')}</Title>
        <Description>{t('publisher.modal.leavePaymentForm.text')}</Description>
        <ButtonsContainer data-repa='modal-leavePaymentForm-buttons'>
          <ExitButton type='button' onClick={handleClick} data-repa='modal-leavePaymentForm-CTA1'>
            {t('publisher.modal.leavePaymentForm.buttonExit')}
          </ExitButton>
          <ContinueButton type='button' id='continuePayment' onClick={onClose} data-repa='modal-leavePaymentForm-CTA2'>
            {t('publisher.modal.leavePaymentForm.buttonContinue')}
          </ContinueButton>
        </ButtonsContainer>
      </Container>
    </ModalBase>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const Title = styled.h4`
  height: 26px;
  margin: 22px 0px 4px;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
  color: ${select('black')};
`;

const Description = styled.p`
  height: 52px;
  padding: 0 1rem;
  margin-bottom: 20px;
  color: ${select('darkGray')};
  text-align: center;
  white-space: break-spaces;
`;

const buttonStyles = css`
  width: 48%;
  height: 40px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
  cursor: pointer;
`;

const ContinueButton = styled.button`
  color: ${select('white')};
  background-color: ${getColor('primary')};
  ${buttonStyles}
`;

const ExitButton = styled.button`
  color: ${select('black')};
  background-color: ${select('white')};
  border: 1px solid ${getColor('primary')};
  ${buttonStyles}
`;

export { LeavePaymentForm };
